import PageHeader from "@/components/layout/PageHeader";
import Testimonials from "@/components/sections/Testimonials";
import Certifications from "@/components/sections/Certifications";
import ContactBlock from "@/components/sections/ContactBlock";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";

export default function ReviewsPage() {
  return (
    <div data-testid="reviews-page">
      <PageHeader
        overline="Reviews"
        title="Trusted by homeowners across LA."
        sub="We take pride in delivering professional service and quality workmanship on every project. Here's what our customers have to say."
        image="https://images.pexels.com/photos/4800189/pexels-photo-4800189.jpeg"
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Reviews" }]}
      />

      <section className="section-pad bg-white border-y border-brand-line">
        <div className="container-page grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="text-center md:text-left">
            <p className="overline">Rating</p>
            <p className="font-heading text-7xl font-extrabold tracking-tighter text-brand-ink">5.0</p>
            <div className="flex justify-center md:justify-start gap-0.5 mt-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-brand-obsidian text-brand-obsidian" />
              ))}
            </div>
            <p className="body-sm mt-3">Based on customer feedback across our projects.</p>
          </div>
          <div>
            <p className="overline">Why customers refer us</p>
            <h2 className="heading-3 mt-3">Communication, cleanliness and craft.</h2>
            <p className="body-sm mt-3">Across the board, our highest-rated traits are clear communication, on-time scheduling and a clean job site every day.</p>
          </div>
          <div>
            <p className="overline">Want to share yours?</p>
            <p className="body-sm mt-3">Already worked with us? We'd love to hear about it. Reach out and we'll send a quick review link.</p>
          </div>
        </div>
      </section>

      <Testimonials />

      <Certifications />

      <section className="section-pad">
        <div className="container-page">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {TESTIMONIALS.map((t, i) => (
              <article key={i} className="card-base p-7" data-testid={`review-card-${i}`}>
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="w-4 h-4 fill-brand-obsidian text-brand-obsidian" />
                  ))}
                </div>
                <p className="font-heading text-xl text-brand-ink leading-snug">"{t.text}"</p>
                <p className="mt-5 text-sm font-semibold text-brand-ink">{t.name} — {t.location}</p>
                <p className="text-xs text-brand-ash">{t.project}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ContactBlock source="reviews_page" />
    </div>
  );
}
